"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExampleHookUseSearch = void 0;

var react_1 = __importDefault(require("react"));

var hooks_1 = require("../../hooks");

var ExampleHookUseSearch = function ExampleHookUseSearch() {
  var searchHook = (0, hooks_1.useSearch)();
  var handleFormSubmit = react_1.default.useCallback(function (event) {
    event.preventDefault();
    searchHook.submitSearchTerm();
  }, [searchHook.submitSearchTerm]);
  var handleInputChange = react_1.default.useCallback(function (event) {
    searchHook.setSearchTerm(event.target.value);
  }, [searchHook.setSearchTerm]);
  return react_1.default.createElement("form", {
    onSubmit: handleFormSubmit
  }, react_1.default.createElement("input", {
    type: "text",
    value: searchHook.searchTerm,
    onChange: handleInputChange
  }));
};

exports.ExampleHookUseSearch = ExampleHookUseSearch;